import { render, staticRenderFns } from "./JavaView.vue?vue&type=template&id=16841cbe&"
import script from "./JavaView.vue?vue&type=script&lang=js&"
export * from "./JavaView.vue?vue&type=script&lang=js&"
import style0 from "./JavaView.vue?vue&type=style&index=0&id=16841cbe&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports